var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCross = function SvgCross(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentColor",
    d: "M17.7045 6.29412C18.0983 6.68629 18.0983 7.32212 17.7045 7.71428L13.4007 12L17.7045 16.2857C18.0984 16.6779 18.0984 17.3137 17.7045 17.7059C17.3107 18.098 16.6722 18.098 16.2784 17.7059L11.9746 13.4201L7.72142 17.6554C7.3276 18.0476 6.68909 18.0476 6.29527 17.6554C5.90145 17.2632 5.90145 16.6274 6.29527 16.2352L10.5484 12L6.29535 7.76476C5.90153 7.37259 5.90153 6.73676 6.29535 6.3446C6.68917 5.95243 7.32768 5.95243 7.7215 6.3446L11.9746 10.5798L16.2783 6.29412C16.6721 5.90196 17.3106 5.90196 17.7045 6.29412Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCross);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "Cross.bc39b664570cdce2ce54d53aa8ae171d.svg";